import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next.handle(authReq).pipe(
      catchError((error) => {
        console.log('ERROR', error)
        if (error.status === 401 && error.error.message === ('Expired JWT Token' || 'JWT Token not found')) {
          return this.authService.refreshToken().pipe(
            switchMap((response) => {
              console.log('RESPONSE', response)
              localStorage.setItem('token', response.token);
              localStorage.setItem('refresh_token', response.refresh_token);
              const newAuthReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${response.token}`,
                },
              });

              return next.handle(newAuthReq);
            }),
            catchError((refreshError) => {
              localStorage.removeItem('token');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('userRole');
              localStorage.removeItem('email');
              return throwError(() => new Error(refreshError));
            })
          );
        }
        return throwError(() => error);
      })
    );
  }
}
